import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'statusFromUrlSent'
})
export class StatusFromUrlSentPipe implements PipeTransform {

  transform(value: any, args?: any): any {
      let valueRet = '';
      try{
          let data = JSON.parse(value);

          if(data.hasOwnProperty('status')){
              valueRet = data.status;
          }

          if(data.hasOwnProperty('status_doi')){
              valueRet = valueRet + ' - ' + data.status_doi;
          }
      }
      catch (e) {
          const query = new URLSearchParams(value);
          if(query.has('status')){
              valueRet = query.get('status');
          }

          if(query.has('status_doi')){
              valueRet = valueRet + ' - ' + query.get('status_doi');
          }
      }

      return valueRet;
  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna_portal/pipes/status-from-url-sent.pipe.ts